export class ExternalReviews {
  static selector = "[data-component=external-reviews]"

  constructor(el) {
    this.root = el
    this.setup()
  }

  changeReview = delta => {
    const
      review = this.container.querySelector(".external-reviews__external-review"),
      containerStyle = window.getComputedStyle(this.container),
      scrollAmt = review.getBoundingClientRect().width
        + parseFloat(containerStyle.getPropertyValue("column-gap"))

    this.container.scrollBy({left: delta * scrollAmt, behavior: "smooth"})
  }

  setup = () => {
    this.container = this.root.querySelector("[data-container]")

    this.root.querySelector("[data-action=left]").addEventListener("click", ev => {
      ev.preventDefault()
      this.changeReview(-1)
    })
    this.root.querySelector("[data-action=right]").addEventListener("click", ev => {
      ev.preventDefault()
      this.changeReview(1)
    })
  }
}
